const apiHandler = async (type = null, data, api = null) => {
  let url;
  const BASE_URL = process.env.REACT_APP_API;
  try {
    if (type === "effort") {
      url = `${BASE_URL}/update-effort`;
    } else if (type === "category") {
      url = `${BASE_URL}/tattle/update-category`;
    } else if (type === "assign_to") {
      url = `${BASE_URL}/tattle/update-assignto`;
    } else if (type === "release") {
      url = `${BASE_URL}/tattle/update-release`;
    } else if (type === "status") {
      url = `${BASE_URL}/tattle/update-status`;
    } else if (type === "external_api" && api) {
      url = new URL(api, BASE_URL).toString();
    } else {
      url = `${BASE_URL}/tattle/update`;
    }

    const response = await fetch(`${url}`, {
      method: "POST",
      body: JSON.stringify(data),
    });

    return await response.json();
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export default apiHandler;
